import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AppConfigService } from '../../services/app-config.service';
import { CustomViewColumn } from '../odata-filter/models/custom-view-column';
import { ViewContext } from '../odata-filter/models/view-context';

@Component({
  selector: 'lineup-manage-columns-sidebar',
  templateUrl: './manage-columns-sidebar.component.html',
  styleUrls: ['./manage-columns-sidebar.component.scss'],
})
export class ManageColumnsSidebarComponent implements OnInit {
  @Output() close = new EventEmitter();
  @Output() open = new EventEmitter();

  @Output() columnsChanged = new EventEmitter<CustomViewColumn[]>();
  @Input() opened = false;
  isSaving = false;
  columns: CustomViewColumn[] = [];
  viewContext: ViewContext;
  constructor(private appConfigService: AppConfigService) {}

  ngOnInit(): void {}
  public edit(columns: CustomViewColumn[], viewContext: ViewContext) {
    this.columns = columns.map((x) => CustomViewColumn.parse(x));
    this.viewContext = viewContext;
    this.open.emit();
    this.opened = true;
  }
  onSave() {
    this.columnsChanged.emit(this.columns);
    this.close.emit();
    this.opened = false;
  }
  onClose() {
    this.close.emit();
    this.opened = false;
  }

  get canManageColumns(): boolean {
    return this.appConfigService.tenant.plan.canManageColumns;
  }
}
